export default __webpack_public_path__ + "static/media/btn-more.9d39c135.svg";